import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { ProductInput, UnitProxy } from "@me-team/host/main/graphql/types";
import { ALT_UNIT_GROUP_NONE_ID } from "../constants";
import { GetUnitsQuery } from "@me-team/host/main/products/graphql/products.hooks";

type FormEffectsProps = {
    pickedCategoryId?: number;
    unitId?: number;
    selectedGroupId?: number;
    unitsData: GetUnitsQuery;
    setSelectedMainUnitId: (id: number | null) => void;
    setRelationsAlternativeUnits: (list: any[] | null) => void;
};

const UpdateProductFormEffects: React.FC<FormEffectsProps> = ({
    pickedCategoryId,
    unitId,
    selectedGroupId,
    unitsData,
    setSelectedMainUnitId,
    setRelationsAlternativeUnits,
}) => {
    const { setFieldValue } = useFormikContext<ProductInput>();

    useEffect(() => {
        if (pickedCategoryId) {
            setFieldValue("category", pickedCategoryId);
        }
    }, [pickedCategoryId, setFieldValue]);

    useEffect(() => {
        if (unitId) {
            setSelectedMainUnitId(unitId);
        }
    }, [unitId, setSelectedMainUnitId]);

    useEffect(() => {
        if (!unitsData) return;

        if (selectedGroupId && selectedGroupId !== ALT_UNIT_GROUP_NONE_ID) {
            const list =
                unitsData.relations?.units?.filter((u: UnitProxy) => u.unitGroup?.id === selectedGroupId) ?? [];
            setRelationsAlternativeUnits(list);
        } else {
            setRelationsAlternativeUnits(null);
        }
    }, [unitsData, selectedGroupId, setRelationsAlternativeUnits]);

    return null;
};

export default UpdateProductFormEffects;
